export default __webpack_public_path__ + "static/media/green.48f9e8dc.svg";